import React, { useMemo } from "react";

import InitialDataListPage from "../components/InitialDataListPage";

const DEFAULT_IMAGE_MIME = "image/png";

const detectImageMime = (value) => {
  if (!value || typeof value !== "string") return DEFAULT_IMAGE_MIME;
  if (value.startsWith("data:image/")) {
    const match = value.match(/^data:(image\/[a-zA-Z0-9.+-]+);base64,/);
    return match ? match[1] : DEFAULT_IMAGE_MIME;
  }
  const signature = value.slice(0, 20);
  if (signature.startsWith("/9j/") || signature.startsWith("/9J/")) return "image/jpeg";
  if (signature.startsWith("iVBOR")) return "image/png";
  if (signature.startsWith("R0lGOD")) return "image/gif";
  if (signature.startsWith("Qk")) return "image/bmp";
  return DEFAULT_IMAGE_MIME;
};

const getImageSrc = (value) => {
  if (!value || typeof value !== "string") return null;
  if (value.startsWith("data:image/")) return value;
  const mime = detectImageMime(value);
  return `data:${mime};base64,${value}`;
};

const PackageMain = ({
  masterList = [],
  name,
  onPageInsert,
  onRowSelected,
  serviceCountByPack = {},
  loading = false,
}) => {
  const columns = useMemo(
    () => [
      {
        key: "index",
        header: "#",
        width: "6%",
        align: "center",
        render: (_item, _index, { startIndex, itemIndex }) =>
          startIndex + itemIndex + 1,
      },
      {
        key: "Pack_Img",
        header: "รูปแพ็คเกจ",
        width: "12%",
        align: "center",
        bodyClassName: "align-top py-2",
        render: (item) => {
          const imgSrc = getImageSrc(item.Pack_Img);
          return imgSrc ? (
            <img
              src={imgSrc}
              alt={item.Pack_Name || "รูปแพ็คเกจ"}
              style={{
                width: "52px",
                height: "52px",
                objectFit: "cover",
                borderRadius: "8px",
                border: "1px solid rgba(0,0,0,0.08)",
              }}
            />
          ) : (
            <span className="text-muted">-</span>
          );
        },
      },
      {
        key: "Pack_Name",
        header: "ชื่อแพ็คเกจ",
        width: "32%",
        align: "start",
        render: (item) => item.Pack_Name || "-",
      },
      {
        key: "service_count",
        header: "จำนวนบริการ",
        width: "16%",
        align: "center",
        render: (item, _index, { extraData }) =>
          extraData?.serviceCountByPack?.[item.Pack_Id] || 0,
      },
      {
        key: "Pack_Status",
        header: "สถานะ",
        width: "14%",
        align: "center",
        render: (item) =>
          item.Pack_Status === "Y" ? "ใช้งาน" : "ไม่ใช้งาน",
      },
      {
        key: "actions",
        header: "แก้ไข",
        width: "6%",
        align: "center",
        isAction: true,
        render: (item, _index, { triggerRowSelected }) => (
          <button
            onClick={(event) => {
              event.stopPropagation();
              triggerRowSelected(item);
            }}
            className="btn btn-sm"
            title="แก้ไข"
            style={{
              width: "32px",
              height: "32px",
              borderRadius: "8px",
              border: "none",
              backgroundColor: "#fff3e0",
              color: "#EF6C00",
              transition: "all 0.2s ease",
            }}
            onMouseOver={(event) => {
              event.currentTarget.style.backgroundColor = "#EF6C00";
              event.currentTarget.style.color = "#fff";
            }}
            onMouseOut={(event) => {
              event.currentTarget.style.backgroundColor = "#fff3e0";
              event.currentTarget.style.color = "#EF6C00";
            }}
            type="button"
          >
            <i className="fas fa-edit" />
          </button>
        ),
      },
    ],
    []
  );

  const getSearchValues = useMemo(
    () => (item) => [
      item?.Pack_Name,
      item?.Pack_Status === "Y" ? "ใช้งาน" : "ไม่ใช้งาน",
    ],
    []
  );

  const extraData = useMemo(
    () => ({
      serviceCountByPack,
    }),
    [serviceCountByPack]
  );

  return (
    <InitialDataListPage
      name={name}
      entityPath="/package"
      data={masterList}
      onCreate={onPageInsert}
      onRowSelected={onRowSelected}
      columns={columns}
      getSearchValues={getSearchValues}
      searchPlaceholder={`ค้นหา${name || "แพ็คเกจ"}...`}
      fieldMappings={{ no: "Pack_Id" }}
      getRowId={(item) => item?.Pack_Id}
      extraData={extraData}
      isLoading={loading}
    />
  );
};

export default PackageMain;
